<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="back" icon="back" bold :text="lang.button_Back"
            :title="lang.button_Back" :disabled="backButtonStatus"/>
          <action-button  @click="newprop" icon="new" bold :text="lang.button_New"
            :title="lang.button_New" :disabled="newpropButtonStatus"/>
          <action-button  @click="save" icon="save" bold :text="lang.button_Save"
            :title="lang.button_Save" :disabled="saveButtonStatus"/>  
          



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold :text="lang.button_Left" :title="lang.button_Left" :disabled="false"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold :text="lang.button_Right" :title="lang.button_Right" :disabled="false"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
import ActionBar from "@/components/shared/ActionBar";
import ActionButton from "@/components/shared/ActionButton";
import ActionContent from "@/components/shared/ActionContent";
import ActionPanel from "@/components/shared/ActionPanel";

import Content from "@/components/ProjectManager/Views/Properties/Middle/Content/Content";

import { mapGetters } from "vuex";

export default {
  name: "Middle",
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props: {
    lang: Object
  },

  data() {
    return {
      newpropButtonStatus: false,
      backButtonStatus: false,
      saveButtonStatus: false,
      exportCisButtonStatus: false,
      saving: false,
      propsTable: ""
    };
  },
  computed: {
    ...mapGetters({
      selectedTreeProjectItemObject: "selectedTreeProjectItemObject"
    }),
    propertyToSaving() {
      return this.$store.getters.propertyToSaving;
    },
    categoryId() {
      if (this.selectedTreeProjectItemObject.categoryId == undefined) {
        return 1;
      }
      return this.selectedTreeProjectItemObject.categoryId;
    }
  },
  created() {},
  methods: {
    validationTable() {
      
      this.propsTable.search("").draw();

      let elements = document.querySelectorAll(".type-props, .browsable-props");

      if (elements.length == 0) {
        const obj = {
          text: this.lang.alert_error_NoProperties,
          time: 15,
          type: "danger"
        };

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }

      let trigLibraryNumber = 0,
        trigLibraryName = 0,
        trigLibraryType = 0,
        trigComment = 0;
      const ob = {};
      for (let i = 0, lei = elements.length; i < lei; i++) {
        if (elements[i].value == "project number") {
          trigLibraryNumber++;
        }
        if (elements[i].value == "project name") {
          trigLibraryName++;
        }
        if (elements[i].value == "project type") {
          trigLibraryType++;
        }
        if (elements[i].value == "comment") {
          trigComment++;
        }
      }

      let isTooMuch = true;
      let what = "";
      if (trigLibraryNumber > 1) {
        isTooMuch = false;
        what = "project number";
      }
      if (trigLibraryName > 1) {
        isTooMuch = false;
        what = "project name";
      }
      if (trigLibraryType > 1) {
        isTooMuch = false;
        what = "project type";
      }
      if (trigComment > 1) {
        isTooMuch = false;
        what = "comment";
      }

      if (isTooMuch == false) {
        const obj = {
          text: this.lang.alert_error_DuplicateProperty + " (" + what + ")",
          time: 15,
          type: "danger"
        };

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      if (trigLibraryNumber == 0) {
        const obj = {
          text: this.lang.alert_error_NoPartNumber,
          time: 15,
          type: "danger"
        };

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      // if (trigLibraryName == 0) {
      //   const obj = {
      //     text: this.lang.alert_error_NoPartName,
      //     time: 15,
      //     type: "danger"
      //   };

      //   this.$store.dispatch("displayFooterAlert", obj);

      //   return false;
      // }
      if (trigLibraryType == 0) {
        const obj = {
          text: this.lang.alert_error_NoLibraryType,
          time: 15,
          type: "danger"
        };

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }

      return true;
    },
    save() {
      let _vue = this;

      let isValid = this.validationTable();

      
      if (!isValid) {
        return;
      }

      for (let i = 0, lei = this.propertyToSaving.length; i < lei; i++) {
        this.propertyToSaving[i].categoryId = this.categoryId;

        this.$store
          .dispatch(
            this.$store.getters.sectionPrefix + "_updateProperty",
            this.propertyToSaving[i]
          )
          .then(function(result) {
            console.log(result);

            if (result.status == "OK") {
              if (i + 1 == lei) {
                const obj = {
                  text: _vue.lang.alert_success_Update,
                  time: 5,
                  type: "success"
                };

                _vue.$store.dispatch("displayFooterAlert", obj);

                //reload table
                const reloadObj = {
                  status: true,
                  name: "FormProjectPropertiesComponent"
                };
                _vue.$store.dispatch("reloadAfterAction", reloadObj);
              } else {
                
              }
            } else {
              const obj = {
                text: _vue.lang.alert_error_Update,
                time: 10,
                type: "danger"
              };

              _vue.$store.dispatch("displayFooterAlert", obj);
            }
          });
      }
      const reloadObj = {
        status: true,
        name: "DataTableFilteredOnApiProjComponent"
      };
      this.$store.dispatch("reloadAfterAction", reloadObj);
    },

    newprop() {
      

      let _vue = this;

      let funcYes = function(e) {
        let form = _vue.$store.getters.createPropertyForm;
        let isRequiredOnRequest = form.checked.includes("isRequiredOnRequest");
        let isRequiredOnRelease = form.checked.includes("isRequiredOnRelease");
        let isRevisionChanging = form.checked.includes("isRevisionChanging");

        let obj = {
          categoryId:
            _vue.$store.getters.selectedTreeProjectItemObject.categoryId,
          name: form.name,
          type: form.type,
          isRequiredOnRequest: isRequiredOnRequest,
          isRequiredOnRelease: isRequiredOnRelease,
          isRevisionChanging: isRevisionChanging
        };

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_createProperty", obj)
          .then(function(result) {
            console.log(result);

            if (result.status == "OK"){

              if (result.data != null){
                const obj = {
                  text: _vue.lang.alert_success_NewProperty,
                  time: 10,
                  type: "success"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);

                const reloadObj = {
                  status: true,
                  name: "FormProjectPropertiesComponent"
                }
                _vue.$store.dispatch("reloadAfterAction", reloadObj);
              }else{
                const obj = {
                  text: _vue.lang.alert_error_NewProperty + ".",
                  time: 15,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }

            }else{
              const obj = {
                text: _vue.lang.alert_error_NewProperty + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);
            }

            
          });
      };

      var obj = {
        text: "",
        type: "new_project_property",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_NewProperty,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);
    },
    back() {

      let to = this.$route.query.from;
      


      

      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },
    toggleRightPanel() {
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
    },
    toggleLeftPanel() {
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
    }
  }
};
</script>


<style scoped>
.middle {
  border-right: 1px solid #666;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/Properties/Middle/Middle.vue